<template>
  <div class="create-serp">
    <div v-if="selectedSerp" class="create-serp__title">Edit Indexation</div>
    <div v-else class="create-serp__title">Create New Indexation</div>
    <label class="create-serp__input">
      <span class="create-serp__label">Active</span>
      <div class="create-serp__link-wrapper" :class="{'create-serp__link-wrapper_single': isDomainDropdownHidden}">
        <base-select
          border-less="true"
          class="create-serp__active"
          :options="activeOpts"
          v-model="serp.is_active"
          alignLeft="true"
          :max-height-list="450"
          :titleStyle="titleStyle"
          :headerStyle="selectTypeStyle"
        />
      </div>
    </label>
    <label class="create-serp__input">
      <span class="create-serp__label">URL</span>
      <div class="create-serp__link-wrapper" :class="{'create-serp__link-wrapper_single': isDomainDropdownHidden}">
        <input type="text"
               class="form-control create-serp__link-field"
               placeholder="Enter the Name for this serp"
               :class="{'form-control_error': externalErrors.url}"
               v-model="serp.url">
        <span class="create-serp__error-message" v-if="externalErrors.url">{{externalErrors.url}}</span>
      </div>
    </label>
    <label class="create-serp__input">
      <span class="create-serp__label">Browser</span>
      <div class="create-serp__link-wrapper" :class="{'create-serp__link-wrapper_single': isDomainDropdownHidden}">
        <base-select
          border-less="true"
          class="create-serp__active"
          :options="browserOpts"
          v-model="serp.browser"
          alignLeft="true"
          :max-height-list="450"
          :titleStyle="titleStyle"
          :headerStyle="selectTypeStyle"
        />
      </div>
    </label>
    <div class="create-serp__controls">
      <button class="create-serp__button create-serp__button_cancel"
              @click.prevent="close()">Cancel
      </button>
      <button v-if="selectedSerp" class="create-serp__button create-serp__button_delete"
              @click.prevent="deleteSerp()">
        Delete
      </button>
      <button class="create-serp__button create-serp__button_submit"
              @click.prevent="apply()">
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import BaseModalMixins from '@/common/BaseModalMixins'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}
const ACTIVE_OPTIONS = [
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
]
const BROWSER_OPTIONS = [
  {
    label: 'Firefox',
    value: 'firefox'
  }
]
export default {
  name: 'CreateUpdateSerpPopup',
  mixins: [BaseModalMixins],
  props: {
    selectedSerp: {
      type: Object
    }
  },
  data () {
    return {
      serp: _.cloneDeep(this.selectedSerp) || {
        is_active: 1,
        url: '',
        browser: 'firefox'
      },
      externalErrors: {
        url: null
      },
      activeOpts: _.cloneDeep(ACTIVE_OPTIONS),
      browserOpts: _.cloneDeep(BROWSER_OPTIONS),
      isValidating: false,
      isDomainDropdownHidden: true,
      elementStyle: {},
      titleStyle: {
        overflow: 'visible'
      },
      selectTypeStyle: _.cloneDeep(SELECT_STYLE)
    }
  },
  methods: {
    close () {
      this.$emit('cancel')
    },
    convertToOptions (item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    showErrors (errors) {
      for (const k in this.externalErrors) {
        this.externalErrors[k] = null
      }

      for (const k in errors) {
        this.externalErrors[k] = errors[k]
      }
    },
    apply () {
      this.$emit('apply', this.serp)
    },
    deleteSerp () {
      this.$emit('delete', this.serp.id)
    }
  }
}
</script>

<style lang="scss">
.create-serp {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 40px;

  &__title {
    text-align: center;
    font-size: 34px;
    font-weight: 500;
    margin: 9px 0 35px;
    color: $rfx-dark-march;
  }

  &__input {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 30px;

    &_invalid[type='text'] {
      border: 1px solid $rfx-red;
      border-radius: 4px;
    }
  }

  &__label {
    display: block;
    font-weight: 600;
    margin-bottom: 5px;
    color: $rfx-dark-march;
  }

  &__controls {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }

  &__button {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    margin-left: 30px;
    border: none;
    outline: none;
    cursor: pointer;

    &_submit {
      background-color: $rfx-medium-march;
      color: #fff;

      &:disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }
    }

    &_delete {
      background-color: $rfx-red;
      color: #fff
    }

    &_disabled {
      pointer-events: none;
      background-color: #fff;
      color: $rfx-neutral-grey;
      cursor: default;
    }

    &_cancel {
      color: $rfx-dark-march;
      background-color: #fff;
    }
  }

  &__link {
    &-wrapper {
      position: relative;
      margin-top: 30px;

      &_single {
        margin-top: 0;
      }
    }

    &-field[type='text'] {
      width: 100%;
      box-sizing: border-box;
      padding-right: 60px;
      font-weight: 500;
      @include ellipsis;
    }
  }

  &__error-message {
    color: $rfx-red;
    font-size: 10px;
    margin-top: 5px;
  }

}

.form-control {
  height: 50px;
  padding: 0 20px;
  border: 2px solid $rfx-light-steel;
  outline: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: $rfx-dark-march;

  &::placeholder {
    color: $rfx-pearl;
    font-weight: normal;
    font-size: 14px;
  }

  &:disabled {
    background-color: $rfx-light-steel;
  }

  &_error {
    border-color: $rfx-red;
    color: $rfx-red;

    &::placeholder {
      color: $rfx-red;
      font-size: 13px;
    }

  }
}

.description {
  width: 100%;
  height: 90%;
  padding: 0;
  resize: none;
  outline: none;
  border: none;
  font-size: 14px;

  &::placeholder {
    color: $rfx-pearl;
    font-weight: normal;
    font-size: 14px;
    margin-top: -5px;
  }

  &__wrapper {
    padding: 10px 20px;
    height: auto;
  }
}

</style>
